




import {SetState} from "@/set/set_store";
import Vue from 'vue'
import {mapState} from "vuex"

export default Vue.extend({
  computed: {
    ...mapState('set', {
      lang: state => (state as SetState).lang
    })
  },
  methods: {
    toggleLang(){
      this.$store.commit('set/toggleLang')
      this.$emit('click')
    }
  },
  filters: {
    upper(s: string): string {
      return s.toUpperCase()
    }
  }
})
